import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=cb01f232&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=cb01f232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb01f232",
  null
  
)

export default component.exports